import { values } from "lodash";
import React, { Fragment } from "react";
import moment from "moment";
const wrapTextFormatter = (value) => {
  return (
    <span
      style={{
        wordWrap: "break-word",
        textAlign: "center",
      }}
    >
      {value || ""}
    </span>
  );
};

const dateFormatter = (value) => {
  if (!value) return "";
  return moment(value).format("MM-DD-YYYY");
};
export const TrackCircuitReportSchemaHeader = {
  heights: {
    header1: "40px",
  },
  classes: {
    header2: "",
  },
  headerOnly: true,
  columns: [
    {
      title: "Track No.",
      colSpan: 2,
      rowSpan: 2,
      isTitleOnly: true,
      accessor: "",
    },

    {
      title: "Track Voltage at Relay",
      colSpan: 2,
      rowSpan: 1,
      isTitleOnly: true,
      columns: [
        { title: "Value", colSpan: 1, rowSpan: 1, isTitleOnly: true },
        { title: "Condition", colSpan: 1, rowSpan: 1, isTitleOnly: true },
      ],
      // value | condition
    },

    {
      title: "Feed End Voltage In Rails",
      colSpan: 2,
      rowSpan: 1,
      isTitleOnly: true,
      columns: [
        { title: "Value", colSpan: 1, rowSpan: 1, isTitleOnly: true },
        { title: "Condition", colSpan: 1, rowSpan: 1, isTitleOnly: true },
      ], // value | condition
    },
    {
      title: "Relay End Voltage In Rails",
      colSpan: 2,
      rowSpan: 1,
      isTitleOnly: true,
      columns: [
        { title: "Value", colSpan: 1, rowSpan: 1, isTitleOnly: true },
        { title: "Condition", colSpan: 1, rowSpan: 1, isTitleOnly: true },
      ], // value | condition
    },
    {
      title: "Track Shunt        .06 ohm",
      colSpan: 1,
      rowSpan: 2,
      isTitleOnly: true,
    },
    {
      title: "Track Condition (Wet/Dry)",
      colSpan: 1,
      rowSpan: 2,
      isTitleOnly: true,
    },
    {
      title: "Changes made",
      colSpan: 3,
      rowSpan: 2,
      isTitleOnly: true,
    },
    {
      title: "Date Taken",
      colSpan: 1,
      rowSpan: 2,
      isTitleOnly: true,
    },
  ],
};
export const TrackCircuitReportSchema = {
  heights: {
    header1: "40px",
  },
  classes: {
    header2: "",
  },
  inlineData: true,
  columns: [
    {
      title: "Track No.",
      colSpan: 2,
      rowSpan: 1,
      accessor: "track",
      formatter: wrapTextFormatter,
      isValueOnly: true,
    },
    {
      title: "Track Voltage at Relay",
      colSpan: 1,
      rowSpan: 1,
      accessor: "trackVoltage",
      isValueOnly: true,
      formatter: wrapTextFormatter,
    },
    {
      title: "Track Voltage at Relay",
      colSpan: 1,
      rowSpan: 1,
      accessor: "tv_test",
      isValueOnly: true,
    },

    {
      title: "Feed End Voltage In Rails ",
      colSpan: 1,
      rowSpan: 1,
      accessor: "feedEndVoltage",
      isValueOnly: true,
      formatter: wrapTextFormatter,
    },
    {
      title: "Feed End Voltage In Rails ",
      colSpan: 1,
      rowSpan: 1,
      accessor: "fev_test",
      isValueOnly: true,
    },
    {
      title: "Relay End Voltage In Rails ",
      colSpan: 1,
      rowSpan: 1,
      accessor: "relayEndVoltage",
      isValueOnly: true,
      formatter: wrapTextFormatter,
    },
    {
      title: "Relay End Voltage In Rails",
      colSpan: 1,
      rowSpan: 1,
      accessor: "rev_test",
      isValueOnly: true,
    },
    {
      title: "Track Shunt. .06ohm",

      rowSpan: 1,
      accessor: ["ts_test"],
      isValueOnly: true,
    },
    {
      title: "Track Condition (Wet/Dry)",

      rowSpan: 1,
      accessor: "trackConditions",
      isValueOnly: true,
    },
    {
      title: "Changes made",

      rowSpan: 1,
      colSpan: 3,
      accessor: ["tv_com", "fev_com", "rev_com", "ts_com"],
      isValueOnly: true,
      dontJoinValues: true,
      leftAlign: true,
      formatter: (values) => {
        const labels = ["Track Voltage at Relay", "Feed End Voltage In Rails", "Relay End Voltage In Rails", "Track Shunt"];

        return (
          <ul style={{ listStyle: "none", padding: 0, marginTop: "-20px" }}>
            {(values || []).map((val, index) => (
              <li key={index} style={{ whiteSpace: "normal", wordBreak: "break-word" }}>
                <span style={{ fontWeight: "bold" }}>{labels[index]}:</span> <span>{val}</span>
              </li>
            ))}
          </ul>
        );
      },
    },
    {
      title: "Date Taken",

      rowSpan: 1,
      accessor: "date",
      isValueOnly: true,
      formatter: dateFormatter,
    },
  ],
};



// WEBPACK FOOTER //
// ./src/components/Reports/PATH/TrackCircuitReport/TrackCircuitReportSchema.jsx